import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ConfirmationModal, useModal } from '@/modules/modals';
import { Heading, Text } from '@/modules/ui';

import { IGNORE_SECURITY_AUDIT_REPORT_MODAL } from '../../constants';
import { ignoreReportSecret } from '../../services/actions';
import type { Secret } from '../../types';
import { heading } from './IgnoreSecurityAuditReportModal.rules';

export const IgnoreSecurityAuditReportModal = () => {
    const { modal, updateModal } = useModal<{
        id: Secret['id'];
    }>(IGNORE_SECURITY_AUDIT_REPORT_MODAL, {
        autoClose: true,
    });

    const dispatch = useDispatch();

    return (
        <ConfirmationModal
            open={modal?.visibility ?? false}
            width={474}
            icon={null}
            okButton={{
                onClick: () => {
                    dispatch(ignoreReportSecret(modal?.data?.id ?? ''));
                    updateModal(false);
                },
                children: <FormattedMessage id='secret.modal.ignoreReport.ok' />,
                'data-testid': 'confirm-button',
            }}
            cancelButton={{
                onClick: () => {
                    updateModal(false);
                },
                children: <FormattedMessage id='secret.modal.ignoreReport.cancel' />,
                'data-testid': 'cancel-button',
            }}
            closable={false}
            dataTestId='ignore-security-audit-report-modal'
        >
            <Heading color='black' customStyle={heading} elementType='h2'>
                <FormattedMessage id='secret.modal.ignoreReport.title' />
            </Heading>
            <Text variant='ParagraphSmallMedium' color='brownGrey'>
                <FormattedMessage id='secret.modal.ignoreReport.text' />
            </Text>
        </ConfirmationModal>
    );
};
